module.exports = __webpack_public_path__ + "static/media/2018_conf_Extraordinary_Results_with_Ordinary_People.aa860850.png";